export default function SelectField({ label, options, value, onChange, placeholder }) {
    return (
      <div className="mb-6">
        <label className="block mb-2 text-sm font-medium text-gray-900 dark:text-white">{label}</label>
        <select
          value={value}
          onChange={onChange}
          className="bg-gray-50 border border-gray-300 text-gray-900 text-sm gap-2.5 rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
        >
          <option className="text-gray-400" value=" ">{placeholder}</option>
          {options.map((opt) => (
           <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
          ))}
        </select>
      </div>
    );
  }